export const authors : { [key: string]: any }
 = {
    "nick": {
        name: "Nicolas Camara",
        img: "/nick-img.jpeg",
        handle: "nickscamara_",
    },
    "caleb": {
        name: "Caleb Peffer",
        img: "/caleb-img.jpeg",
        handle: "CalebPeffer"
    },
    "eric": {
        name: "Eric Ciarla",
        img: "/eric-img.jpeg",
        handle: "ericciarla"
    },
    "garrett": {
        name: "Garrett Frohman",
        img: "/garrett-img.jpeg",
        handle: "garrettfrohman"
    },
    "rafa": {
        name: "Rafael Miller",
        img: "/rafa.jpeg",
        handle: "rafaelmmiller",
    }
}